module.exports = __webpack_public_path__ + "static/media/dancelocation.9025cc8f.png";